import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import {
  SNACKBAR_ROLE_ICONS,
  SnackbarData,
  snackbarShowsCloseButton,
} from './snackbar.model';

@Component({
  selector: 'app-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.scss'],
  imports: [MatButtonModule, MatIconModule, NgClass],
})
export class SnackbarComponent {
  @Input({ required: true }) data!: SnackbarData;
  @Output() dismissed = new EventEmitter<void>();

  get iconName(): string | undefined {
    return (
      this.data.svgIcon ??
      (this.data.role ? SNACKBAR_ROLE_ICONS[this.data.role] : undefined)
    );
  }

  get iconRoleClass(): string | undefined {
    if (!this.data.role) {
      return undefined;
    }

    return `app-snackbar__icon--${this.data.role}`;
  }

  get showAction(): boolean {
    return !!this.data.action;
  }

  get showCloseButton(): boolean {
    return snackbarShowsCloseButton(this.data.duration, this.showAction);
  }

  get hasTrailingControl(): boolean {
    return this.showAction || this.showCloseButton;
  }

  get liveRegionRole(): 'alert' | 'status' {
    return this.data.role === 'error' ? 'alert' : 'status';
  }

  onDismiss(): void {
    this.dismissed.emit();
  }

  onAction(): void {
    this.data.action?.callback();
    this.dismissed.emit();
  }
}
